import React, { useEffect } from 'react'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom';
import { Markup } from 'interweave';
import { ReactSession } from 'react-client-session';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon,
    PinterestIcon,
    EmailIcon
} from "react-share";

import styles from '../../App.module.css';
import classes from './Global.module.css';
import noThumb from "../../images/no-thumb.jpg";

function Weblink(weblink) {
    const { uid } = useParams();
    ReactSession.setStoreType("localStorage");
    const logged_user = ReactSession.get("logged_user");

    if(logged_user) {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/weblinklike.php`, {
            user_id: logged_user,
            weblink_id: weblink.id,
            action: 'isweblinklike'
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if(res.data.islike) {
                weblink.islike = true;
            }else {
                weblink.islike = false;
            }
        }).catch(err => {
            console.log(err);
        })
    }

    const addWeblink = () => {
        const toast_id = toast.loading("Please wait...");
        if(logged_user) {
            axios.post(`${process.env.REACT_APP_API_URL}/api/user/weblinkadd.php`, {
                user_id: logged_user,
                weblink_id: weblink.id,
                action: 'weblinkadd'
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
        }
    }

    const handleLike = (id) => {
        const toast_id = toast.loading("Please wait...");
        if(logged_user) {
            axios.post(`${process.env.REACT_APP_API_URL}/api/user/weblinklike.php`, {
                user_id: logged_user,
                weblink_id: weblink.id,
                action: 'weblinklike'
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if(res.data.message === "Like added") {
                    document.querySelectorAll(`.weblink-${id} .counter`)[0].innerHTML = weblink.rate += 1;
                    document.querySelectorAll(`.weblink-${id} .${classes.like_btn}`)[0].classList.add(classes.liked);
                }else if(res.data.message === "Like removed!") {
                    if(weblink.rate > 0) {
                        document.querySelectorAll(`.weblink-${id} .counter`)[0].innerHTML = weblink.rate -= 1;
                        document.querySelectorAll(`.weblink-${id} .${classes.like_btn}`)[0].classList.remove(classes.liked);
                    }
                }

                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
        }
    }

    const delWeblink = (id) => {
        const weblink = document.getElementById(`weblink_${id}`);
        if(weblink) {
            if(window.confirm("Are you sure you want to delete this weblink?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/weblink.php`, {  
                        uid: logged_user,
                        id: id,
                        action: 'delWeblink'
                    }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }).then(res => {
                        console.log(res.data);
                        
                        if(res.data.status === 'success') {
                            // weblink.remove();
                            toast.update(toast_id, {render: "Weblink deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                        }else {
                            toast.update(toast_id, {render: "Something went wrong!", autoClose: 5000, type: "error", isLoading: false});
                        }
                    }).catch(err => {
                        console.log(err);
                    })
            }
        }
    }

    const config = "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30";

    return (
        <div id={`weblink_${weblink.id}`} data-id={weblink.id} className={`weblink-${weblink.id} card ` + styles.card}>
            <Link to={false}>
                <img className={`card-img-top ` + styles.card_image} src={weblink.thumb} onError={e => {e.target.src = noThumb}} alt={weblink.webTitle} />
            </Link>
            <div className={`card-block text-center ${styles.card_block}`}>
                <div className={styles.cart_content}>
                    <h4 className={styles.card_title}><Markup content={weblink.webTitle}></Markup></h4>
                    <p className={styles.card_text}><Markup content={weblink.description}></Markup></p>
                </div>
                <div className={classes.card_bottom}>
                    <div className={styles.social_share_buttons}>
                        <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://twitter.com/intent/tweet?url=https://wesharez.com/weblink/${weblink.id}/${weblink.nice_url}&text=${weblink.webTitle}`, "Popup", config)}>
                            <TwitterIcon size={32} round={true} />
                        </Link>
                        <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=https://wesharez.com/weblink/${weblink.id}/${weblink.nice_url}&title=${weblink.webTitle}`, "Popup", config)}>
                            <LinkedinIcon size={32} round={true} />
                        </Link>
                        <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://pinterest.com/pin/create/link/?url=https://wesharez.com/group/${weblink.id}/${weblink.nice_url}&title=${weblink.webTitle}&media=${weblink.thumb}&description=${weblink.webTitle}`, "Popup", config)}>
                            <PinterestIcon size={32} round={true} />
                        </Link>
                        <a className={`${styles.social__icon}`} href={`whatsapp://send?text=https://wesharez.com/group/${weblink.id}/${weblink.nice_url}`} data-action="share/whatsapp/share">
                            <WhatsappIcon size={32} round={true} />
                        </a>
                        <a className={`${styles.social__icon}`} href={`mailto:?subject=${weblink.webTitle}&body=https://wesharez.com/group/${weblink.id}/${weblink.nice_url}`}>
                            <EmailIcon size={32} round={true} />
                        </a>
                    </div>
                    <div className={classes.btn_group}>
                        <a href={weblink.webUrl} target="_blank" rel="noreferrer" title="Visit">
                            <button className={`btn ${classes.add_btn}`} type="submit">Visit</button>
                        </a>
                        {
                            (uid === undefined || (uid !== logged_user)) && <button className={`${classes.add_btn} btn`} onClick={addWeblink}><i className="fa-solid fa-square-plus"></i> ADD</button>
                        }
                        {
                            (uid !== undefined && (uid === logged_user)) && <button className={`${classes.del_btn} btn`} onClick={() => delWeblink(weblink.id)}><i className="fa-solid fa-trash-can"></i> Delete</button>
                        }
                    </div>
                    <div className={`${classes.meta} row`}>
                        <div className="col-6">
                            <span className={classes.views}>{weblink.view_count} views</span>
                        </div>
                        <div className="col-6">
                            <button className={`like_btn ${classes.like_btn} btn ${weblink.islike && classes.liked}`} onClick={() => handleLike(weblink.id)}>
                                <i className="fa-solid fa-thumbs-up"></i>
                                <span><span className="counter">{weblink.rate}</span> likes</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Weblink